import { MetricsSC } from "./metrics.styles";

const WebMetrics = () => {
    return <MetricsSC>
        <div className="stat-item">
            <h3>7+</h3>
            <p>Years of Experience</p>
        </div>

        <div className="stat-divider" />

        <div className="stat-item">
            <h3>250+</h3>
            <p>Trusted clients</p>
        </div>

        <div className="stat-divider" />

        <div className="stat-item">
            <h3>1000+</h3>
            <p>Counselling Sessions</p>
        </div>

        <div className="stat-divider" />

        <div className="stat-item">
            <h3>10+</h3>
            <p>Public Speaking Sessions</p>
        </div>
    </MetricsSC>
}

const MobileMetrics = () => {
    return <MetricsSC>
        <div className="mobile-row">
            <div className="stat-item">
                <h3>7+</h3>
                <p>Years of Experience</p>
            </div>

            <div className="stat-divider" />

            <div className="stat-item">
                <h3>250+</h3>
                <p>Trusted</p>
                <p>clients</p>
            </div>
        </div>

        <div className="stat-line-divider" />
        <div className="mobile-row">
            <div className="stat-item">
                <h3>1000+</h3>
                <p>Counselling Sessions</p>
            </div>

            <div className="stat-divider" />

            <div className="stat-item">
                <h3>10+</h3>
                <p>Public Speaking Sessions</p>
            </div>
        </div>
        {/* // <div className="stat-divider" /> */}

    </MetricsSC >
}

const Metrics = () => {
    return window.screen.width > 768 ? <WebMetrics /> : <MobileMetrics />
}

export default Metrics;